import { render, staticRenderFns } from "./OrderDeliveryAddressMap.vue?vue&type=template&id=58245616&scoped=true"
import script from "./OrderDeliveryAddressMap.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryAddressMap.vue?vue&type=script&lang=js"
import style0 from "./OrderDeliveryAddressMap.vue?vue&type=style&index=0&id=58245616&prod&lang=css"
import style1 from "./OrderDeliveryAddressMap.vue?vue&type=style&index=1&id=58245616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58245616",
  null
  
)

export default component.exports